import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cn } from '@/utils/cn';
import { addCartItemsAsync } from '@/redux/thunk/carts-thunk';
import { pageTypes } from '@/constants/types';
import { addToCartGTMEvent } from '@/utils/analytics';
import AddToCartButton from './AddToCart';
import LoadingToCartButton from './LoadingToCart';

function AddToCartActionWithLoadingButton({
  currentProduct,
  pageType = pageTypes.categoricalProduct,
  showLarge = false,
}) {
  const dispatch = useDispatch();
  const { isHalt } = useSelector((state) => state.carts);

  const productCount = useSelector((state) => {
    const product = state.carts.items.find(
      (item) => item.id === currentProduct?.id,
    );
    return product ? product.cart_quantity : 0;
  });

  const [loadingCart, setLoadingCart] = useState(false);

  const handleAddToCart = async (e, productData) => {
    e.stopPropagation();
    e.preventDefault();
    setLoadingCart(() => true);

    const updatedProduct = {
      ...productData,
      id: productData.id,
      cart_quantity: 1,
    };

    (async () => {
      try {
        // Add to cart and wait for completion
        await dispatch(addCartItemsAsync({ product: updatedProduct })).unwrap();

        // Only trigger GTM event if cart addition was successful
        addToCartGTMEvent({ productData, cartQuantity: 1 });
      } catch (error) {
        console.error('Error adding item into the cart:', error);
      }
    })();
  };

  useEffect(() => {
    if (!isHalt) {
      setLoadingCart(isHalt);
    }
  }, [isHalt]);

  return (
    <div>
      {loadingCart ? (
        <LoadingToCartButton
          className={cn('w-[160px] lg:w-[200px] h-[24px] lg:h-[36px]', {
            'w-[124px] lg:w-[201px]': pageType === pageTypes.categoricalProduct,
            'w-[96px] lg:w-[160px]': pageType === pageTypes.comparison,
            'w-[140px] lg:w-[164px] h-[24px] lg:h-[36px]':
              pageType === pageTypes.myOrder,
          })}
          iconStyle={showLarge ? '24' : ''}
          labelStyle={cn('text-xs lg:text-sm', {
            'text-sm lg:text-sm': showLarge,
          })}
        />
      ) : (
        <AddToCartButton
          pageType={pageType}
          flexibleIconSize={false}
          productCount={productCount}
          hideIcon={pageType === pageTypes.comparison}
          onClick={(e) => {
            handleAddToCart(e, currentProduct);
          }}
        />
      )}
    </div>
  );
}

export default AddToCartActionWithLoadingButton;
